import React from 'react';
import autobind from 'autobind-decorator';
import {Dropdown, DropdownButton} from 'react-bootstrap';

import {service as ActivityFeedFilterService} from "../../../Services/ActivityFeedFilterService";
import {ObjectUtils} from "../../../Utils";

export class SubscriptionsPageRecord extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: []
        };
    }

    componentDidMount() {
        ActivityFeedFilterService.Get()
            .then((x) => {
                if(!ObjectUtils.Compare(this.state.filters, x.result)) {
                    this.setState({filters: x.result});
                }
            });
    }

    @autobind
    getTitle() {
        let item = this.state.filters.find((x) => x.activityFeedFilterId == this.props.Item.activityFeedFilterId);

        if(item) {
            return item.name;
        }

        return "All";
    }

    @autobind
    update(x) {
        this.props.UpdateItem(x);
    }

    render() {
        return <DropdownButton
            title={this.getTitle()}
            id={"subscription-filter-selection-" + this.props.Key}
        >
            {
                this.state.filters.map((x) =>
                    <Dropdown.Item
                        key={x.activityFeedFilterId}
                        eventKey={x.activityFeedFilterId}
                        onClick={() => this.update(x.activityFeedFilterId)}
                    >
                        {x.name}
                    </Dropdown.Item>
                )
            }
            <Dropdown.Item
                eventKey={"all"}
                onClick={() => this.update(null)}
            >
                All
            </Dropdown.Item>
        </DropdownButton>;
    }
}


